import { useProgressChecklistPlatform } from './useProgressChecklistPlatform'
import * as Components from '../components'

export function useProgressChecklistComponent() {
  const platformProps = useProgressChecklistPlatform()

  // Select which result to use based on feature flag
  if (platformProps === 'loading') {
    return 'loading' as const
  }

  return <Components.ProgressChecklistItem {...platformProps} />
}
